import { tableCellClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useSelloutTableStyles = makeStyles()(() => ({
  table: {
    [`& .${tableCellClasses.root}`]: {
      border: 'none',
      padding: '0 2px',
      textAlign: 'center',
    },
  },
}));

export default useSelloutTableStyles;
